import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../supabaseClient';

export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    const page     = location.pathname;
    const referrer = document.referrer || 'Direct';

    // Don't track admin/auth pages
    if (page.startsWith('/login') || page.startsWith('/register') || page.startsWith('/reset')) return;

    supabase.from('page_views').insert({
      page,
      referrer,
    }).then(({ error }) => {
      if (error) console.error('Page view tracking error:', error);
    });
  }, [location.pathname]);

  return null;
}